import React, { memo } from "react";
import LuckyDrawFormComponent from "./luckyDrawForm.component";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";

const TYPES = ["new", "edit", "readonly"];

function LuckyDrawFormContainer({
  type,
  handleResult,
  initialValues,
  handleDelete,
  handleClose,
}) {
  const lang = useSelector((state) => state.constant.languages);

  return (
    <LuckyDrawFormComponent
      type={type}
      handleSubmit={handleResult}
      handleDelete={handleDelete}
      initialValues={initialValues}
      lang={lang}
      handleClose={handleClose}
    />
  );
}

LuckyDrawFormContainer.defaultProps = {
  type: TYPES[0],
};

LuckyDrawFormContainer.propTypes = {
  type: PropTypes.oneOf(TYPES).isRequired,
  handleResult: PropTypes.func,
  handleDelete: PropTypes.func,
};

export { TYPES };

export default memo(LuckyDrawFormContainer, (oldProps, newProps) => {
  return (
    oldProps.initialValues === newProps.initialValues ||
    oldProps.initialValues?.id === newProps.initialValues?.id
  );
});
